import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as _moment from 'moment';

const moment = _moment;

@Component({
    selector: 'receive-single-settlement-dialog',
    templateUrl: './receive-single-settlement-dialog.component.html',
    styleUrls: ['./receive-single-settlement-dialog.component.scss'],
})
export class ReceiveSingleSettlementDialogComponent {
    paymentDate = new FormControl(moment());

    constructor(
        public dialogRef: MatDialogRef<ReceiveSingleSettlementDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    get total(): number {
        return this.data?.total ?? 0;
    }

    cancel(): void {
        this.dialogRef.close();
    }

    confirm(): void {
        this.dialogRef.close({
            paymentDate: moment(this.paymentDate.value).toISOString(),
        });
    }
}
